import { AlertColor, SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { ReactNode } from 'react'

export enum StaticView {
  DASHBOARD = 'overview',
  REPORTS = 'reports',
  HELP = 'help',
  ETRLKPIS = 'etrl-kpis',
  UPLOAD = 'upload-files',
  ETL = 'etl',
  PTHOME = 'pt-home',
  PTKPIS = 'pt-kpis',
  PTASSISSTANCE = 'pt-assistance',
  PTDATAUPLOADSTEPS = 'pt-datauploadsteps',
}

export enum Module {
  PAY = 'pay',
  CAREER = 'career',
  WORKING_TIME = 'working_time',
  TRAINING = 'training',
}

export enum DiversityDimension {
  GENDER = 'gender',
  DISABILITY = 'disability',
  ORIGIN = 'german',
  MIGRATION_BACKGROUND = 'migration_background',
  AGE = 'age_groups',
}

export interface FsRoute {
  path: string
  name: string
  index?: boolean
  component: ReactNode
}

export interface SeverityMessage {
  severity: AlertColor | undefined
  message: string | undefined
}

export interface FsIcon {
  key: string
  icon: React.ReactNode
}

export interface Icon {
  key: string
  icon:
    | React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>
    | (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
        muiName: string
      })
}

export interface FakeOptionForAction {
  valueToAchieve: number
  cost: number
}

export interface ModuleConfig {
  module: Module
  fsColor: FsColor
  /**
   * unit, used as key for translation files
   */
  unit?: string
  numberFractionDigit: 0 | 1 | 2
  fakeOptions: FakeOptionForAction[]
}

export interface DiversityDimenstionConfig {
  diversityDimension: DiversityDimension
  fsColor: FsColor
}

export interface FsColor {
  key:
    | 'fsPurple'
    | 'fsBlue'
    | 'fsDarkBlue'
    | 'fsMagenta'
    | 'fsLightGreen'
    | 'fsLightOrange'
    | 'fsGreen'
    | 'fsLightBlue'
    | 'fsOrange'
    | 'fsGray'
  primary: string
  light: string
  colors: string[]
}

export interface ReportsAvailableType {
  reportId: number
  reportModule: Module
  name: string
  isAvailable: boolean
  theme?: any
}

export interface ETRLKPI {
  id: string
  type: number
  name: string
  kpiResult: string
  euGuidelineNumber: string
  variable: string | null
  variableType: string | null
  variableDescription: {
    cwi: string | null
    de: string | null
    en: string | null
  }
}

export interface PTRun {
  id: number
  runAt: Date
  year: number
  isCompleted: boolean
  noOfEmployees: number
}

export interface PTKPI {
  id: string
  type: number
  name: string
  kpiResult: string
  euGuidelineNumber: string
  variable: string | null
  variableType: string | null
  variableDescription: {
    cwi: string | null
    de: string | null
    en: string | null
  }
}

export interface PTKldB {
  id: number
  titleEn: string
  titleDe: string
}

export interface PTInteractiveResultValue {
  id: string
  order: number
  salary: number | null
  employees: number
}

export interface PTInteractiveResult {
  type: string
  id: number
  order: number
  values: PTInteractiveResultValue[]
}
